"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsRoutes = void 0;
var tslib_1 = require("tslib");
var getIsRoutes = function (_a) {
    var _b = _a.pathname, pathname = _b === void 0 ? '' : _b, routes = _a.routes;
    var isRoutesMeta = {
        isDeprecatedRoute: false,
        isPreLoginRoute: false,
        isNotFoundRoute: true,
        useLayout: 'one',
    };
    var isRoutes = {};
    for (var _i = 0, _c = Object.entries(routes); _i < _c.length; _i++) {
        var _d = _c[_i], key = _d[0], route = _d[1];
        if (pathname === route.pathname) {
            isRoutes[key] = true;
            isRoutesMeta.isDeprecatedRoute = !!route.isDeprecated;
            isRoutesMeta.isPreLoginRoute = !!route.isPreLogin;
            isRoutesMeta.useLayout = route.useLayout;
            isRoutesMeta.isNotFoundRoute = false;
        }
        else {
            isRoutes[key] = false;
        }
    }
    return tslib_1.__assign(tslib_1.__assign({}, isRoutes), isRoutesMeta);
};
exports.getIsRoutes = getIsRoutes;
